export default {
  includesOneMonth: {
    en: 'Includes one month of Scentbird Free*',
  },
  textInfo: {
    en: `
    *New subscribers only, cannot be combined with any other offer.
    Voucher is transferrable to friends and family. Voucher is not
    redeemable for any remaining value in cash or credit, unless required by law.
  `,
  },
  addToCart: {
    en: 'Add to cart',
  },
  outOfStock: {
    en: 'OUT OF STOCK',
  },
}
